import React from "react";
import Page from "../../organisms/Page";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import { Row, Col, Card } from "react-bootstrap";
import MenuItemCard from "../../organisms/MenuItemCard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import { useUsuarioActual } from "../../../services/authServicios";
import {
  puedeAccederRuta,
} from "../../../services/rolAutorizacion";
import {
  RUTA_ANALISIS_OPERACIONES_ASISTENCIAS_POR_DIAS,
  RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS_POR_DIA,
  RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS,
  RUTA_ANALISIS_OPERACIONES_MASCOTAS_DESERTORAS,
  RUTA_ANALISIS_OPERACIONES_VACUNAS_VENCIDAS,
} from "../../../services/rutas";

const breadCrumbs: BreadCrumbItem[] = [
  { path: "/", label: "Inicio" },
  { path: "/analisis", label: "Análisis" },
  { path: "/analisis/operaciones", label: "Operaciones", isActive: true },
];

function Operaciones() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Page
      title="Análisis Operativos"
      description="Informes e indicadores operativos."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <div className="col-xs-12 col-md-12 col-lg-11 col-xxl-8">
          <Card>
            <Card.Body>
              <Row className="justify-content-center mb-2 p-2">
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_OPERACIONES_ASISTENCIAS_POR_DIAS
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={CalendarMonthIcon}
                      ruta={RUTA_ANALISIS_OPERACIONES_ASISTENCIAS_POR_DIAS}
                      titulo="Asistencias por días"
                      descripcion="Resumen diario de asistencias."
                    />
                  </CardCol>
                )}
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={MiscellaneousServicesIcon}
                      ruta={RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS}
                      titulo="Lista de Planes Activos"
                      descripcion="Planes de guardería activos."
                    />
                  </CardCol>
                )}
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS_POR_DIA
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={FactCheckIcon}
                      ruta={RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS_POR_DIA}
                      titulo="Planes Activos Por Día"
                      descripcion="Planes vigentes por fecha y tipo de servicio."
                    />
                  </CardCol>
                )}
              </Row>
              <Row className="justify-content-center mb-2 p-2">
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_OPERACIONES_MASCOTAS_DESERTORAS
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={DirectionsRunIcon}
                      ruta={RUTA_ANALISIS_OPERACIONES_MASCOTAS_DESERTORAS}
                      titulo="Mascotas desertoras"
                      descripcion="Mascotas que dejaron de agendar planes de guardería."
                    />
                  </CardCol>
                )}
                {puedeAccederRuta(
                  usuario,
                  RUTA_ANALISIS_OPERACIONES_VACUNAS_VENCIDAS
                ) && (
                  <CardCol>
                    <MenuItemCard
                      Icono={VaccinesIcon}
                      ruta={RUTA_ANALISIS_OPERACIONES_VACUNAS_VENCIDAS}
                      titulo="Vacunas vencidas"
                      descripcion="Control de vacunas pendientes o vencidas."
                    />
                  </CardCol>
                )}
              </Row>
            </Card.Body>
          </Card>
        </div>
      </Row>
    </Page>
  );
}

const CardCol = ({ children }: { children: React.ReactNode }) => (
  <Col xs={12} md={4} sm={6}>
    {children}
  </Col>
);

export default Operaciones;
